import {aggregateAssessmentStandards} from 'components/standards-selector/domain/assessment-aggregation.cjs'
import fetch from 'helpers/command'
import {isUUID} from 'helpers/utils'
import {updateLoadableList} from 'helpers/context'

export const subjects = fetchDE('subjects')
export const grades = fetchDE('grades')
export const standards = fetchDE('standards')
export const expectations = fetchDE('expectations')

const hooks =  [
    {paths: ['page/', 'operation/', 'query/', 'sectionName/'], fetches:[subjects, grades, standards, expectations]},
    {paths: ['page/', 'assessment/', 'action/', 'sectionName/', 'assignmentId/'], fetches:[getAssessmentStandards]},
]

export {hooks as default}

function fetchDE (entity) {
  return async ({operation, sectionName, query, updateState, languageId: language}) => {
    if (operation != 'add-standards' && sectionName != 'standards-search') return
    const entityPath = `standardsContext.${entity}`
    updateState(updateLoadableList(entityPath))
    const items = await fetch('de', entity)({language, ...query})
    updateState(updateLoadableList(entityPath, items))
  }
}
export async function getAssessmentStandards ({updateState, assessment, page, assignmentId, tab}) {
  const id = assignmentId || assessment
  if (!isUUID(id)) return


  updateState(
    updateLoadableList('standardsContext.assessmentStandards'),
    {standardsContext: {assessment: {$set: {}}, assessmentIndicators: {}}}
  )

  const [standards, expectations, indicators, assessmentProperties] = await fetch('quiz', 'getAssessmentStandards')({id})

  const {standards: parsedStandards, assessmentIndicators} = aggregateAssessmentStandards(standards, expectations, indicators)

  updateState(
    updateLoadableList('standardsContext.assessmentStandards', parsedStandards),
    {standardsContext: {assessment: {$set: assessmentProperties}, assessmentIndicators: {$set: assessmentIndicators}}}
  )

}
